import { useCallback, useState } from 'react';
import useUI from '../../context/useUI';
import useHttp from '../../http/useHttp';

export default function usePostAssociations(custodianId: any) {
  const { showSnackbar } = useUI();
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const { postDataResponse, postData } = useHttp();

  const edit = useCallback(async (model: any) => {
    const associations = model;
    try {
      setIsSaving(true);
      const result = await postData('EntityRelationship/save', associations);
      setIsSaving(false);
      if (result) {
        showSnackbar(['Association saved successfully!'], 'success');
        return true;
      }
    } catch (error) {
      setIsSaving(false);
    }
  }, []);

  return { isSaving, data: postDataResponse?.data ?? null, edit };
}
